const DEFAULT_CONFIG = {
	//TokenName
	TOKEN_NAME: "Authorization",

	//Token前缀，注意最后有个空格，如不需要需设置空字符串
	TOKEN_PREFIX: "Bearer ",

	API_URL: process.env.VUE_APP_URL,


}



export default DEFAULT_CONFIG